var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#353740",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0625 3.375C4.13052 3.375 3.375 4.13052 3.375 5.0625C3.375 5.99448 4.13052 6.75 5.0625 6.75C5.99448 6.75 6.75 5.99448 6.75 5.0625C6.75 4.13052 5.99448 3.375 5.0625 3.375ZM1.875 5.0625C1.875 3.30209 3.30209 1.875 5.0625 1.875C6.82291 1.875 8.25 3.30209 8.25 5.0625C8.25 6.82291 6.82291 8.25 5.0625 8.25C3.30209 8.25 1.875 6.82291 1.875 5.0625Z",
    fill: "fillCurrent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9375 3.375C12.0055 3.375 11.25 4.13052 11.25 5.0625C11.25 5.99448 12.0055 6.75 12.9375 6.75C13.8695 6.75 14.625 5.99448 14.625 5.0625C14.625 4.13052 13.8695 3.375 12.9375 3.375ZM9.75 5.0625C9.75 3.30209 11.1771 1.875 12.9375 1.875C14.6979 1.875 16.125 3.30209 16.125 5.0625C16.125 6.82291 14.6979 8.25 12.9375 8.25C11.1771 8.25 9.75 6.82291 9.75 5.0625Z",
    fill: "fillCurrents"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0625 11.25C4.13052 11.25 3.375 12.0055 3.375 12.9375C3.375 13.8695 4.13052 14.625 5.0625 14.625C5.99448 14.625 6.75 13.8695 6.75 12.9375C6.75 12.0055 5.99448 11.25 5.0625 11.25ZM1.875 12.9375C1.875 11.1771 3.30209 9.75 5.0625 9.75C6.82291 9.75 8.25 11.1771 8.25 12.9375C8.25 14.6979 6.82291 16.125 5.0625 16.125C3.30209 16.125 1.875 14.6979 1.875 12.9375Z",
    fill: "fillCurrent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9375 11.25C12.0055 11.25 11.25 12.0055 11.25 12.9375C11.25 13.8695 12.0055 14.625 12.9375 14.625C13.8695 14.625 14.625 13.8695 14.625 12.9375C14.625 12.0055 13.8695 11.25 12.9375 11.25ZM9.75 12.9375C9.75 11.1771 11.1771 9.75 12.9375 9.75C14.6979 9.75 16.125 11.1771 16.125 12.9375C16.125 14.6979 14.6979 16.125 12.9375 16.125C11.1771 16.125 9.75 14.6979 9.75 12.9375Z",
    fill: "fillCurrent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsNotification);
export default __webpack_public_path__ + "static/media/dotsNotification.bbbb6793f96cac9dc43e3b4c51904f28.svg";
export { ForwardRef as ReactComponent };